export { default } from './CardParent';
export type { AgreementWithValueChange, ChildType } from './CardParent';
